import { interfaces } from '@daas-consulting/core-cross-interfaces';
import * as store from '@daas-consulting/core-frontend-store';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { context, feature } from '../remitos.const';

const loadItemsActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.list,
  action: store.ListActionNames.loadItems,
});

export class LoadItems {
  static readonly type = `${loadItemsActions.action}`;
}

export class LoadItemsRequest {
  static readonly type = `${loadItemsActions.request}`;
}

export class LoadItemsSuccessful {
  static readonly type = `${loadItemsActions.successful}`;
  constructor(
    readonly payload: interfaces.PagedList<models.RemitoListItemModel>
  ) { }
}

export class LoadItemsFailure {
  static readonly type = `${loadItemsActions.failure}`;
  constructor(readonly payload: Error) { }
}

export class SetFilter {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.setFilter,
  });
  constructor(readonly payload?: Partial<interfaces.CriteriaRequest>) { }
}

export class SetFullFilter {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: `${store.ListActionNames.setFilter} full`,
  });
  constructor(readonly payload?: Partial<interfaces.CriteriaRequest>) { }
}

export class RemoveFilter {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.removeFilter,
  });
  constructor(readonly payload: string) { }
}

export class ResetPagination {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.resetPagination,
  });
}

export class SetPagination {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.setPagination,
  });
  constructor(readonly payload: { pageIndex: number; pageSize: number }) { }
}

export class SetFiltersInUrl {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.setFiltersInUrl,
  });
}

export class SetOrder {
  static readonly type = store.getActionName({
    context,
    feature,
    section: store.SectionsNames.list,
    action: store.ListActionNames.setOrder,
  });
  constructor(readonly payload: interfaces.Order) { }
}

const cancelItemActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.list,
  action: 'cancel item',
});

export class CancelItem {
  static readonly type = `${cancelItemActions.action}`;
  constructor(
    readonly payload: { remitoId: string; canceledReason: string }
  ) { }
}

export class CancelItemRequest {
  static readonly type = `${cancelItemActions.request}`;
}

export class CancelItemSuccessful {
  static readonly type = `${cancelItemActions.successful}`;
}

export class CancelItemFailure {
  static readonly type = `${cancelItemActions.failure}`;
  constructor(readonly payload: Error) { }
}
